var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderZippediconbreadscrumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.9C0 0.402944 0.402944 0 0.9 0H5.0187C5.23354 0 5.44129 0.076853 5.60441 0.216669L7.68496 2H13.4333C13.9304 2 14.3333 2.40294 14.3333 2.9V10.7667C14.3333 11.2637 13.9304 11.6667 13.4333 11.6667H0.9C0.402943 11.6667 0 11.2637 0 10.7667V0.9ZM1 1V4.66667H13.3333V3H7.64797C7.43313 3 7.22538 2.92315 7.06226 2.78333L4.9817 1H1ZM13.3333 5.66667H1V10.6667H13.3333V5.66667Z",
    fill: "#656579"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4.83301,
    width: 1,
    height: 2,
    fill: "#656579"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4.83301,
    width: 1,
    height: 2,
    fill: "#656579"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3.83301,
    width: 1,
    height: 1,
    fill: "#656579"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.83301,
    width: 1,
    height: 1,
    fill: "#656579"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3.83301,
    width: 1,
    height: 1,
    fill: "#656579"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3.83301,
    width: 1,
    height: 1,
    fill: "#656579"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3.83301,
    width: 1,
    height: 1,
    fill: "#656579"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 3.83301,
    width: 1,
    height: 1,
    fill: "#656579"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4.83301,
    width: 1,
    height: 2,
    fill: "#656579"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4.83301,
    width: 1,
    height: 2,
    fill: "#656579"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4.83301,
    width: 1,
    height: 2,
    fill: "#656579"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4.83301,
    width: 1,
    height: 2,
    fill: "#656579"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 4.83301,
    width: 1,
    height: 2,
    fill: "#656579"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4.83301,
    width: 1,
    height: 2,
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderZippediconbreadscrumb);
export default __webpack_public_path__ + "static/media/Folder_Zippediconbreadscrumb.8015c090e2320dd26f6300c0003d80f5.svg";
export { ForwardRef as ReactComponent };